import React, { useState } from 'react';
import { Row, Col, Container, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
import { Link } from 'react-router-dom';
//icons
import {
  AiOutlineInstagram,
  AiOutlineFacebook,
  AiOutlineX
} from 'react-icons/ai';
//api
import { postSubscriptionEmail } from 'api/company';
//constants
import { emailRegex } from '../../constants';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//images icons
import letterIcon from 'assets/img/ico_newsletter.png';
//styles
import './subscriptionForm.scss';

const SubscriptionForm = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [acceptedPolicies, setAcceptedPolicies] = useState(false);
  const { t } = useTranslation(['footer', 'backoffice']);
  const { redes_sociales, is_single_company } = useCompanyStore();
  const { assignedLibrary } = useAssignedLibrary();

  const registerEmail = async (event) => {
    event.preventDefault();
    const emailValid = emailRegex.test(email);
    if (!emailValid) {
      setFeedback(t('validemail'));
      return;
    }
    if (!acceptedPolicies) {
      return;
    }
    setFeedback('');
    const payload = { email };
    try {
      const { status } = await postSubscriptionEmail(payload);
      if (status === 201) {
        setRegisterSuccess(true);
        setEmail('')
        setAcceptedPolicies(false);
      } else if (status === 400) {
        setFeedback(t('emailregistered'));
        setEmail('')
        setAcceptedPolicies(false);
        setRegisterSuccess(false);
      } else {
        setFeedback(`${t('internalerror')} (${status}). ${t('trylater')}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setFeedback(`${t('internalerror')} ${t('trylater')}`);
    }
  };

  const socialMediaIcons = {
    instagram: { icon: <AiOutlineInstagram size={30} />, alt: t('instagramicon'), name: t('instagram', { ns: 'backoffice' }) },
    facebook: { icon: <AiOutlineFacebook size={30} />, alt: t('facebookicon'), name: t('facebook', { ns: 'backoffice' }) },
    twitter: { icon: <AiOutlineX size={30} />, alt: t('twittericon'), name: t('twitter', { ns: 'backoffice' }) },
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Container fluid className={`${is_single_company && `container-suscription`} w-100 px-0 text-black`} >
      <Col xs={12} className="container container-responsive mainDiv">
        <Row className="subscription-row ">
          <Col xs={12} sm={10} md={10} lg={5}>
            <Row className="overflow-hidden">
              <Col lg={10} className="mb-4  d-flex overflow-hidden">
                <Col xs={2} sm={2} md={2} lg={2} className="d-flex mx-3">
                  <Link
                    to={`/${assignedLibrary}/condiciones-de-uso/nuevas-condiciones`}
                    className="d-flex w-100"
                    onClick={goUp}
                  >
                    <img src={letterIcon} alt="A letter icon" data-testid="iconletter" />
                  </Link>
                </Col>
                <Col xs={9} sm={9} md={9} lg={9} className="px-0">
                  <p className="ms-3">
                    <strong>{t('suscribeteNewsletterUno')} </strong> {t('suscribeteNewsletterDos')}
                  </p>
                </Col>
              </Col>
              <Col lg={10} className="d-flex justify-content-center ml-5">
                <Col md={7} lg={9} xs={7} className="d-flex justify-content-center">
                  <Form.Control
                    id="inlineFormInput"
                    data-testid="inlineFormInput"
                    placeholder={t('tuCorreo')}
                    onChange={(e) => {
                      const value = e.target.value;
                      setEmail(value);
                      setFeedback('');
                      setAcceptedPolicies(false);
                      setRegisterSuccess(false);
                    }}
                    value={email}
                    className="pl-0 input-subscription"
                  />
                </Col>
                <Col sm={3} md={3} lg={3}>
                  <Button disabled={!acceptedPolicies || registerSuccess} onClick={registerEmail} className="border-radius-button">
                    {t('subscribe')}
                  </Button>
                </Col>
              </Col>
              <Col lg={10} className="mt-3 d-flex">
                <Form.Check
                  type="checkbox"
                  checked={acceptedPolicies}
                  onChange={(e) => setAcceptedPolicies(e.target.checked)} className="container-checkbox"
                />
                <p className="ms-2">
                  {t('aceptarPoliticasUno')}
                  <Link
                    to={`/${assignedLibrary}/aviso-legal-politica-privacidad`}
                    onClick={goUp}
                    className="global-link"
                  >
                    <span> {t('aceptarPoliticasDos')}</span>
                  </Link>
                  <Link
                    to={`/${assignedLibrary}/condiciones-de-uso/nuevas-condiciones`}
                    onClick={goUp}
                    className="global-link"
                  >
                    <span> {t('aceptarPoliticasTres')}.</span>
                  </Link>
                </p>
              </Col>
              {registerSuccess && (
                <Col className="alert-success" lg={12} data-testid="success-message">
                  <span>{t('emailregisteredsuccessfully')} </span>
                </Col>
              )}
              {feedback && <span className="feedback text-danger">{feedback}</span>}
            </Row>
          </Col>
          <Col xs={9} sm={4} md={4} lg={2} className="social-col mt-sm-3 mt-md-3 mt-lg-0">
            <Row>
              {Object.keys(redes_sociales).map((key) => {
                const social = socialMediaIcons[key];
                if (!social) return null;
                return (
                  <Col lg={12} className="mb-4 px-xl-5 px-lg-3 px-md-3 px-sm-3" key={key}>
                    <Row>
                      <a className="d-flex ml-4 gap-2 justify-content-center" href={redes_sociales[key]} target="_blank" rel="noopener noreferrer">
                        <Col xs={3} lg={3} md={3} className='hover-text'>
                          {social.icon}
                        </Col>
                        <Col xs={6} sm={9} md={7} lg={10}>
                          <p className='p-1 hover-text'>{social.name}</p>
                        </Col>
                      </a>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* <Col xs={9} sm={4} md={4} lg={4} className="appCol mt-4 mt-sm-3 mt-md-3 mt-lg-0">
            <Row>
              <Col lg={12} className="mb-4">
                <Row className="justify-content-start">
                  <Col xs={2} sm={2} md={2} lg={2} className="pl-4 text-end">
                    <img src={appsIcon} alt={t('appsicon')} className="phone-img" />
                  </Col>
                  <Col xs={9} sm={9} md={9} lg={9} className="p-0 text-start">
                    <p>
                      <strong>{t('descargateAppUno')}</strong>
                      {t('descargateAppDos')}
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col lg={10}>
                <Row className="justify-content-start appImg">
                  {apps_urls?.google_play && (
                    <Col xs={6} sm={6} md={6} lg={6} className="d-flex justify-content-center">
                      <a href={apps_urls.google_play} target="_blank" rel="noopener noreferrer">
                        <img src={googleIcon} alt={t('googleicon')} />
                      </a>
                    </Col>
                  )}
                  {apps_urls?.app_store && (
                    <Col xs={6} sm={6} md={6} lg={6} className="p-0">
                      <a href={apps_urls.app_store} target="_blank" rel="noopener noreferrer">
                        <img src={appleIcon} alt={t('appleicon')} />
                      </a>
                    </Col>
                  )}
                </Row>
              </Col> 
            </Row>
          </Col>*/}
        </Row>
      </Col>
    </Container>
  );
};

export default SubscriptionForm;